export default {
    "en-US": {
        "language": "en",
        "region": "US",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "nl-NL": {
        "language": "nl",
        "region": "NL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ca-AD": {
        "language": "ca",
        "region": "AD",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ru-RU": {
        "language": "ru",
        "region": "RU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "el-GR": {
        "language": "el",
        "region": "GR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GB": {
        "language": "en",
        "region": "GB",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    'sr-RS': {
        "language": "sr",
        "region": "RS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "de-DE": {
        "language": "de",
        "region": "DE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sk-SK": {
        "language": "sk",
        "region": "SK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "nl-BE": {
        "language": "nl",
        "region": "BE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ro-RO": {
        "language": "ro",
        "region": "RO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "hu-HU": {
        "language": "hu",
        "region": "HU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ro-MD": {
        "language": "ro",
        "region": "MD",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "da-DK": {
        "language": "da",
        "region": "DK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-IE": {
        "language": "en",
        "region": "IE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fi-FI": {
        "language": "fi",
        "region": "FI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "tr-TR": {
        "language": "tr",
        "region": "TR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "uk-UA": {
        "language": "uk",
        "region": "UA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-PT": {
        "language": "pt",
        "region": "PT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "sl-SI": {
        "language": "sl",
        "region": "SI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "lb-LU": {
        "language": "lb",
        "region": "LU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-ES": {
        "language": "es",
        "region": "ES",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "mt-MT": {
        "language": "mt",
        "region": "MT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "sv-FI": {
        "language": "sv",
        "region": "FI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "be-BY": {
        "language": "be",
        "region": "BY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-MC": {
        "language": "fr",
        "region": "MC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "el-CY": {
        "language": "el",
        "region": "CY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "no-NO": {
        "language": "no",
        "region": "NO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-FR": {
        "language": "fr",
        "region": "FR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sr-ME": {
        "language": "sr",
        "region": "ME",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "cs-CZ": {
        "language": "cs",
        "region": "CZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "lv-LV": {
        "language": "lv",
        "region": "LV",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "it-IT": {
        "language": "it",
        "region": "IT",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "it-SM": {
        "language": "it",
        "region": "SM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "bs-BA": {
        "language": "bs",
        "region": "BA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "mk-MK": {
        "language": "mk",
        "region": "MK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "bg-BG": {
        "language": "bg",
        "region": "BG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sv-SE": {
        "language": "sv",
        "region": "SE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "et-EE": {
        "language": "et",
        "region": "EE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sq-AL": {
        "language": "sq",
        "region": "AL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "de-LI": {
        "language": "de",
        "region": "LI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "it-VA": {
        "language": "it",
        "region": "VA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "de-AT": {
        "language": "de",
        "region": "AT",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "lt-LT": {
        "language": "lt",
        "region": "LT",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pl-PL": {
        "language": "pl",
        "region": "PL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "hr-HR": {
        "language": "hr",
        "region": "HR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "de-CH": {
        "language": "de",
        "region": "CH",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-CA": {
        "language": "en",
        "region": "CA",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "fr-CI": {
        "language": "fr",
        "region": "CI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GH": {
        "language": "en",
        "region": "GH",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-DZ": {
        "language": "fr",
        "region": "DZ",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "it-ER": {
        "language": "it",
        "region": "ER",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-ML": {
        "language": "fr",
        "region": "ML",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-CF": {
        "language": "fr",
        "region": "CF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GM": {
        "language": "en",
        "region": "GM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-GW": {
        "language": "pt",
        "region": "GW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-MW": {
        "language": "en",
        "region": "MW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-CG": {
        "language": "fr",
        "region": "CG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-BI": {
        "language": "fr",
        "region": "BI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-EG": {
        "language": "ar",
        "region": "EG",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "coptic",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-MA": {
        "language": "fr",
        "region": "MA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "am-ET": {
        "language": "am",
        "region": "ET",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "ethiopic"
        ]
    },
    "fr-GN": {
        "language": "fr",
        "region": "GN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-SN": {
        "language": "fr",
        "region": "SN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sw-TZ": {
        "language": "sw",
        "region": "TZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-DJ": {
        "language": "fr",
        "region": "DJ",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-CM": {
        "language": "fr",
        "region": "CM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-SL": {
        "language": "en",
        "region": "SL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-BW": {
        "language": "en",
        "region": "BW",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-ZW": {
        "language": "en",
        "region": "ZW",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-ZA": {
        "language": "en",
        "region": "ZA",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-SS": {
        "language": "en",
        "region": "SS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-UG": {
        "language": "en",
        "region": "UG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-SD": {
        "language": "ar",
        "region": "SD",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "rw-RW": {
        "language": "rw",
        "region": "RW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-CD": {
        "language": "fr",
        "region": "CD",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-NG": {
        "language": "en",
        "region": "NG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-GA": {
        "language": "fr",
        "region": "GA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-TG": {
        "language": "fr",
        "region": "TG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-AO": {
        "language": "pt",
        "region": "AO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-ZM": {
        "language": "en",
        "region": "ZM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-GQ": {
        "language": "es",
        "region": "GQ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-MZ": {
        "language": "pt",
        "region": "MZ",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-LS": {
        "language": "en",
        "region": "LS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-SZ": {
        "language": "en",
        "region": "SZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "so-SO": {
        "language": "so",
        "region": "SO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-LR": {
        "language": "en",
        "region": "LR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sw-KE": {
        "language": "sw",
        "region": "KE",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "fr-TD": {
        "language": "fr",
        "region": "TD",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-NE": {
        "language": "fr",
        "region": "NE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-MR": {
        "language": "fr",
        "region": "MR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-BF": {
        "language": "fr",
        "region": "BF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-BJ": {
        "language": "fr",
        "region": "BJ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-ST": {
        "language": "pt",
        "region": "ST",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-LY": {
        "language": "ar",
        "region": "LY",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-TN": {
        "language": "ar",
        "region": "TN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "en-NA": {
        "language": "en",
        "region": "NA",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-AG": {
        "language": "en",
        "region": "AG",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "pt-BR": {
        "language": "pt",
        "region": "BR",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-AR": {
        "language": "es",
        "region": "AR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-AW": {
        "language": "en",
        "region": "AW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-PY": {
        "language": "es",
        "region": "PY",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-MX": {
        "language": "es",
        "region": "MX",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-BB": {
        "language": "en",
        "region": "BB",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-BZ": {
        "language": "en",
        "region": "BZ",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "fr-CA": {
        "language": "fr",
        "region": "CA",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-CO": {
        "language": "es",
        "region": "CO",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-VE": {
        "language": "es",
        "region": "VE",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-KY": {
        "language": "en",
        "region": "KY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "nl-CW": {
        "language": "nl",
        "region": "CW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-DM": {
        "language": "en",
        "region": "DM",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-SV": {
        "language": "es",
        "region": "SV",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "da-GL": {
        "language": "da",
        "region": "GL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-TC": {
        "language": "en",
        "region": "TC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GD": {
        "language": "en",
        "region": "GD",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-GP": {
        "language": "fr",
        "region": "GP",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-GT": {
        "language": "es",
        "region": "GT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-EC": {
        "language": "es",
        "region": "EC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GY": {
        "language": "en",
        "region": "GY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-CU": {
        "language": "es",
        "region": "CU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-JM": {
        "language": "en",
        "region": "JM",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-BO": {
        "language": "es",
        "region": "BO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-PE": {
        "language": "es",
        "region": "PE",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-SX": {
        "language": "en",
        "region": "SX",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-NI": {
        "language": "es",
        "region": "NI",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "fr-MF": {
        "language": "fr",
        "region": "MF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-MQ": {
        "language": "fr",
        "region": "MQ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-PM": {
        "language": "fr",
        "region": "PM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-UY": {
        "language": "es",
        "region": "UY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-BS": {
        "language": "en",
        "region": "BS",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-PA": {
        "language": "es",
        "region": "PA",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "nl-SR": {
        "language": "nl",
        "region": "SR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ht-HT": {
        "language": "ht",
        "region": "HT",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-TT": {
        "language": "en",
        "region": "TT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-PR": {
        "language": "es",
        "region": "PR",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "es-CL": {
        "language": "es",
        "region": "CL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-KN": {
        "language": "en",
        "region": "KN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-LC": {
        "language": "en",
        "region": "LC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-VI": {
        "language": "en",
        "region": "VI",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-VC": {
        "language": "en",
        "region": "VC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "es-HN": {
        "language": "es",
        "region": "HN",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-VG": {
        "language": "en",
        "region": "VG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-AU": {
        "language": "en",
        "region": "AU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ja-JP": {
        "language": "ja",
        "region": "JP",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "japanese"
        ]
    },
    "nb-NO": {
        "language": "nb",
        "region": "NO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-YE": {
        "language": "ar",
        "region": "YE",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "kk-KZ": {
        "language": "kk",
        "region": "KZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-JO": {
        "language": "ar",
        "region": "JO",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "tk-TM": {
        "language": "tk",
        "region": "TM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-IQ": {
        "language": "ar",
        "region": "IQ",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-BH": {
        "language": "ar",
        "region": "BH",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic-umalqura",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "az-AZ": {
        "language": "az",
        "region": "AZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "th-TH": {
        "language": "th",
        "region": "TH",
        "firstDayOfWeek": 7,
        "calendar": [
            "buddhist",
            "gregory"
        ]
    },
    "ar-LB": {
        "language": "ar",
        "region": "LB",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ky-KG": {
        "language": "ky",
        "region": "KG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ms-BN": {
        "language": "ms",
        "region": "BN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "hi-IN": {
        "language": "hi",
        "region": "IN",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "indian"
        ]
    },
    "mn-MN": {
        "language": "mn",
        "region": "MN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "zh-CN": {
        "language": "zh",
        "region": "CN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "chinese"
        ]
    },
    "si-LK": {
        "language": "si",
        "region": "LK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-SY": {
        "language": "ar",
        "region": "SY",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "bn-BD": {
        "language": "bn",
        "region": "BD",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "pt-TL": {
        "language": "pt",
        "region": "TL",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-AE": {
        "language": "ar",
        "region": "AE",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic-umalqura",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "tg-TJ": {
        "language": "tg",
        "region": "TJ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "tr-CY": {
        "language": "tr",
        "region": "CY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-PS": {
        "language": "ar",
        "region": "PS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "vi-VN": {
        "language": "vi",
        "region": "VN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "zh-HK": {
        "language": "zh",
        "region": "HK",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "chinese"
        ]
    },
    "id-ID": {
        "language": "id",
        "region": "ID",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "he-IL": {
        "language": "he",
        "region": "IL",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "hebrew",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fa-AF": {
        "language": "fa",
        "region": "AF",
        "firstDayOfWeek": 6,
        "calendar": [
            "persian",
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ur-PK": {
        "language": "ur",
        "region": "PK",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ne-NP": {
        "language": "ne",
        "region": "NP",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "ms-MY": {
        "language": "ms",
        "region": "MY",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-KW": {
        "language": "ar",
        "region": "KW",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic-umalqura",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "zh-MO": {
        "language": "zh",
        "region": "MO",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "chinese"
        ]
    },
    "tl-PH": {
        "language": "fil",
        "region": "PH",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "ar-OM": {
        "language": "ar",
        "region": "OM",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-QA": {
        "language": "ar",
        "region": "QA",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic-umalqura",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ar-SA": {
        "language": "ar",
        "region": "SA",
        "firstDayOfWeek": 7,
        "calendar": [
            "islamic-umalqura",
            "gregory",
            "islamic",
            "islamic-rgsa"
        ]
    },
    "ko-KR": {
        "language": "ko",
        "region": "KR",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "dangi"
        ]
    },
    "en-SG": {
        "language": "en",
        "region": "SG",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "chinese"
        ]
    },
    "zh-TW": {
        "language": "zh",
        "region": "TW",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "roc",
            "chinese"
        ]
    },
    "uz-UZ": {
        "language": "uz",
        "region": "UZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "ka-GE": {
        "language": "ka",
        "region": "GE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fa-IR": {
        "language": "fa",
        "region": "IR",
        "firstDayOfWeek": 6,
        "calendar": [
            "persian",
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "dz-BT": {
        "language": "dz",
        "region": "BT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "lo-LA": {
        "language": "lo",
        "region": "LA",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "my-MM": {
        "language": "my",
        "region": "MM",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "hy-AM": {
        "language": "hy",
        "region": "AM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-BM": {
        "language": "en",
        "region": "BM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "pt-CV": {
        "language": "pt",
        "region": "CV",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fo-FO": {
        "language": "fo",
        "region": "FO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "is-IS": {
        "language": "is",
        "region": "IS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GS": {
        "language": "en",
        "region": "GS",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-SH": {
        "language": "en",
        "region": "SH",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-FK": {
        "language": "en",
        "region": "FK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-NZ": {
        "language": "en",
        "region": "NZ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-PT": {
        "language": "en",
        "region": "PT",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-TK": {
        "language": "en",
        "region": "TK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-KI": {
        "language": "en",
        "region": "KI",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-PK": {
        "language": "en",
        "region": "PK",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "en-BD": {
        "language": "en",
        "region": "BD",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "en-KH": {
        "language": "en",
        "region": "KH",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "mg-MG": {
        "language": "mg",
        "region": "MG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-IO": {
        "language": "en",
        "region": "IO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-CX": {
        "language": "en",
        "region": "CX",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "chinese"
        ]
    },
    "ms-CC": {
        "language": "ms",
        "region": "CC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "ar-KM": {
        "language": "ar",
        "region": "KM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "fr-TF": {
        "language": "fr",
        "region": "TF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-SC": {
        "language": "fr",
        "region": "SC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "dv-MV": {
        "language": "dv",
        "region": "MV",
        "firstDayOfWeek": 5,
        "calendar": [
            "gregory",
            "islamic-civil",
            "islamic-tbla"
        ]
    },
    "en-MU": {
        "language": "en",
        "region": "MU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-YT": {
        "language": "fr",
        "region": "YT",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-RE": {
        "language": "fr",
        "region": "RE",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sm-WS": {
        "language": "sm",
        "region": "WS",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-PG": {
        "language": "en",
        "region": "PG",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-FM": {
        "language": "en",
        "region": "FM",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "bi-VU": {
        "language": "bi",
        "region": "VU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-FJ": {
        "language": "en",
        "region": "FJ",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-TV": {
        "language": "en",
        "region": "TV",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-PF": {
        "language": "fr",
        "region": "PF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-SB": {
        "language": "en",
        "region": "SB",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-GU": {
        "language": "en",
        "region": "GU",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-MH": {
        "language": "en",
        "region": "MH",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-UM": {
        "language": "en",
        "region": "UM",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-NR": {
        "language": "en",
        "region": "NR",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-NU": {
        "language": "en",
        "region": "NU",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-NF": {
        "language": "en",
        "region": "NF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-NC": {
        "language": "fr",
        "region": "NC",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "sm-AS": {
        "language": "sm",
        "region": "AS",
        "firstDayOfWeek": 7,
        "calendar": [
            "gregory"
        ]
    },
    "en-PW": {
        "language": "en",
        "region": "PW",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-PN": {
        "language": "en",
        "region": "PN",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-CK": {
        "language": "en",
        "region": "CK",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-MP": {
        "language": "en",
        "region": "MP",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "to-TO": {
        "language": "to",
        "region": "TO",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "fr-WF": {
        "language": "fr",
        "region": "WF",
        "firstDayOfWeek": 1,
        "calendar": [
            "gregory"
        ]
    },
    "en-KW": {
        "language": "en",
        "region": "KW",
        "firstDayOfWeek": 6,
        "calendar": [
            "gregory",
            "islamic-umalqura",
            "islamic",
            "islamic-civil",
            "islamic-tbla"
        ]
    }
}